import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme: Theme) => ({
  card: {
    backgroundColor: theme.palette.background.default,
    border: 'none',
    boxShadow: 'none',
    borderRadius: '30px',
    height: '100%',
    padding: '10px',
    display: 'flex',
    flexDirection: 'column'
  },
  img: {
    width: '100%',
    borderRadius: '20px',
    aspectRatio: '16/9',
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: 'auto'
    }
  },
  cardContent: {
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    flexGrow: 1
  },
  titleWrapper: {
    marginTop: theme.spacing(1),
    minHeight: '2.4em'
  },
  displayNone: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  actions: {
    alignSelf: 'flex-end',
    marginTop: 'auto',
    paddingBottom: '8px'
  },
  actionsSkeleton: {
    width: '80px'
  }
}))
